// ============================================================
// PDP Buy box JS
// Shared across all product pages
// ============================================================

// Preços lidos do HTML renderizado pelo Liquid (section settings)
function bbRead(bundle, sel, fallback) {
  var el = document.querySelector('[data-bundle="' + bundle + '"] ' + sel);
  return el ? el.textContent.trim() : fallback;
}
var bundleData = {
  single: { price: bbRead('single', '.bb-now', ''), was: bbRead('single', '.bb-was', ''), label: '1 par' },
  duo:    { price: bbRead('duo', '.bb-now', ''),    was: bbRead('duo', '.bb-was', ''),    label: 'Vanta Duo' },
  kit:    { price: bbRead('kit', '.bb-now', ''),    was: bbRead('kit', '.bb-was', ''),    label: 'Pack 3 lentes' }
};

// Variant ID do produto actual (injectado pelo Liquid)
var currentVariantId = document.getElementById('bb-cta')?.dataset.variantId || '';

function updateStickyDetail(bundle) {
  var d = bundleData[bundle];
  var stickyDetail = document.getElementById('sticky-detail');
  if (stickyDetail && d) stickyDetail.innerHTML = '<span class="sticky-price">' + d.price + '</span><span class="sticky-qty">' + d.label + '</span>';
}

function updateCta(bundle, price) {
  var ctaBtn = document.getElementById('bb-cta');
  if (!ctaBtn || ctaBtn.disabled) return;
  var label = ctaBtn.querySelector('.bb-cta-label');
  var priceEl = ctaBtn.querySelector('.bb-cta-price');
  var stickyBtn = document.querySelector('.sticky-btn');
  if (priceEl) priceEl.textContent = price || '';
  if (bundle === 'single') {
    if (label) label.textContent = 'Adicionar ao carrinho';
    ctaBtn.dataset.action = 'cart';
    if (stickyBtn) stickyBtn.innerHTML = 'Adicionar <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
  } else {
    if (label) label.textContent = 'Finalizar compra';
    ctaBtn.dataset.action = 'checkout';
    if (stickyBtn) stickyBtn.textContent = 'Finalizar compra';
  }
}

// URL de checkout directo para o pack activo
function checkoutUrl() {
  var ctaBtn = document.getElementById('bb-cta');
  if (!ctaBtn) return '/checkout';
  var bundle = document.querySelector('.bb-opt.is-active')?.dataset.bundle;
  var url = null;
  if (bundle === 'duo') {
    var activeLens = document.querySelector('.bb-lens.is-active')?.dataset.lens;
    // getAttribute (não .dataset) porque handles de produto podem ter hífens,
    // e o dataset faz camelCase automático que não corresponde ao handle real.
    url = activeLens ? ctaBtn.getAttribute('data-checkout-duo-' + activeLens) : null;
  } else if (bundle === 'kit') {
    url = ctaBtn.getAttribute('data-checkout-kit');
  } else {
    url = '/cart/' + ctaBtn.dataset.variantId + ':1?checkout';
  }
  return url || '/checkout';
}

function handleCta() {
  var ctaBtn = document.getElementById('bb-cta');
  if (!ctaBtn) return;
  if (duoNeedsLens()) return;

  if (ctaBtn.dataset.action === 'cart') {
    var label = ctaBtn.querySelector('.bb-cta-label');
    var originalText = label ? label.textContent : '';
    if (label) label.textContent = 'A adicionar...';

    // Single — add to cart e abre drawer
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: ctaBtn.dataset.variantId, quantity: 1 })
    })
    .then(function() {
      // Abrir a drawer e actualizar o conteúdo (badge, itens, temporizador
      // da reserva, etc.) — reutiliza exactamente a mesma função do ícone
      // do carrinho no header, para não duplicar esta lógica em dois
      // sítios com comportamentos diferentes.
      if (window.vantaCartOpen) {
        window.vantaCartOpen();
      } else {
        // Fallback caso o header ainda não tenha corrido (não devia acontecer)
        var overlay = document.getElementById('cart-overlay');
        var drawer = document.getElementById('cart-drawer');
        if (overlay) overlay.classList.add('open');
        if (drawer) { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
        if (window.vantaRefreshCart) window.vantaRefreshCart();
      }
      if (label) label.textContent = originalText;
    })
    .catch(function() {
      if (label) label.textContent = originalText;
    });

  } else {
    // Duo / Kit — checkout directo
    goCheckout();
  }
}

// Feedback ao seguir para o checkout: bloqueia duplo clique e mostra "A abrir…"
var checkoutBusy = false;
var busyRestore = [];
function goCheckout() {
  if (checkoutBusy) return;
  checkoutBusy = true;
  [
    ['#bb-cta', '.bb-cta-label'],
    ['.sticky-btn', null],
    ['#mbway-btn', '.bb-mbway-title']
  ].forEach(function(pair) {
    var btn = document.querySelector(pair[0]);
    if (!btn) return;
    var txt = pair[1] ? btn.querySelector(pair[1]) : btn;
    if (!txt) return;
    busyRestore.push({ btn: btn, txt: txt, html: txt.innerHTML });
    txt.textContent = 'A abrir checkout...';
    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');
  });
  window.location.href = checkoutUrl();
}

// Voltar atrás com bfcache devolve a página no estado "a abrir": repõe os botões
window.addEventListener('pageshow', function(e) {
  if (!e.persisted || !checkoutBusy) return;
  busyRestore.forEach(function(r) {
    r.txt.innerHTML = r.html;
    r.btn.classList.remove('is-busy');
    r.btn.removeAttribute('aria-busy');
  });
  busyRestore = [];
  checkoutBusy = false;
});

// MB WAY — vai direto ao checkout do pack activo, onde o MB WAY já está disponível
function handleMbway() {
  if (duoNeedsLens()) return;
  goCheckout();
}

function selectBundle(el) {
  document.querySelectorAll('.bb-opt').forEach(function(o) {
    o.classList.remove('is-active');
    o.setAttribute('aria-checked', 'false');
  });
  el.classList.add('is-active');
  el.setAttribute('aria-checked', 'true');
  var bundle = el.dataset.bundle;
  var d = bundleData[bundle];
  if (!d) return;
  updateCta(bundle, d.price);
  updateStickyDetail(bundle);
}

// Teclado: Enter / Espaço activam opções de pack e lentes
document.addEventListener('keydown', function(e) {
  if (e.key !== 'Enter' && e.key !== ' ') return;
  var t = e.target;
  if (t && t.classList && (t.classList.contains('bb-opt') || t.classList.contains('bb-lens') || t.classList.contains('bb-slot--pick'))) {
    e.preventDefault();
    t.click();
  }
});

// ── PRELOAD de todas as imagens da galeria ──
(function() {
  document.querySelectorAll('.gallery-thumb[data-src]').forEach(function(thumb) {
    var img = new Image();
    img.src = thumb.dataset.src;
  });
})();

function selectThumb(el, idx) {
  document.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
  el.classList.add('active');
  var main = document.getElementById('gallery-main-img');
  if (main && el.dataset.src) {
    main.style.transition = 'none';
    main.src = el.dataset.src;
    main.alt = el.dataset.alt || '';
  }
}

// Abre/fecha a lista de lentes ao clicar no card vazio (selecciona o Duo)
function toggleDuoPicker(e) {
  e.stopPropagation();
  var duoOpt = document.querySelector('.bb-opt[data-bundle="duo"]');
  if (!duoOpt) return;
  if (!duoOpt.classList.contains('is-active')) selectBundle(duoOpt);
  openDuoPop();
}

function openDuoPop() {
  var pop = document.getElementById('duo-pop');
  if (!pop) return;
  // Move para o body para escapar a overflow/transform dos ancestrais
  if (pop.parentNode !== document.body) document.body.appendChild(pop);
  pop.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  var slot = document.getElementById('duo-slot');
  if (slot) slot.setAttribute('aria-expanded', 'true');
}

function closeDuoPop() {
  var pop = document.getElementById('duo-pop');
  if (pop) pop.classList.remove('is-open');
  document.body.style.overflow = '';
  var slot = document.getElementById('duo-slot');
  if (slot) slot.setAttribute('aria-expanded', 'false');
}

document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDuoPop(); });

// Duo sem 2.ª lente escolhida: não deixa avançar, abre a lista
function duoNeedsLens() {
  var active = document.querySelector('.bb-opt.is-active');
  if (!active || active.dataset.bundle !== 'duo') return false;
  if (document.querySelector('.bb-lens.is-active')) return false;
  openDuoPop();
  return true;
}

function selectDuo(e, el) {
  e.stopPropagation();
  document.querySelectorAll('.bb-lens').forEach(function(o) { o.classList.remove('is-active'); });
  el.classList.add('is-active');

  // Preenche o card da 2.ª lente e fecha a lista
  var slot = document.getElementById('duo-slot');
  if (slot) {
    var src = el.querySelector('img');
    var sImg = slot.querySelector('.bb-slot-img');
    if (sImg && src) { sImg.src = src.currentSrc || src.src; sImg.hidden = false; }
    var n = el.querySelector('.bb-lens-name');
    var sn = slot.querySelector('.bb-slot-name');
    if (sn && n) sn.textContent = n.textContent;
    var ss = slot.querySelector('.bb-slot-sub');
    if (ss) ss.textContent = '2.ª lente · alterar';
    slot.classList.add('is-filled');
  }
  closeDuoPop();

  var price = el.dataset.price;
  var duoOpt = document.querySelector('.bb-opt[data-bundle="duo"]');
  if (!price || !duoOpt) return;
  var set = function(sel, txt) { var n = duoOpt.querySelector(sel); if (n && txt) n.textContent = txt; };
  set('.bb-now', price);
  set('.bb-was', el.dataset.compare);
  set('.bb-save-amt', el.dataset.save ? 'Poupas ' + el.dataset.save : '');
  set('.bb-pp', el.dataset.pp ? el.dataset.pp + ' por par' : '');
  bundleData.duo.price = price;
  bundleData.duo.was = el.dataset.compare;
  // Picker sempre visível: escolher uma lente selecciona o Duo
  if (duoOpt.classList.contains('is-active')) {
    updateCta('duo', price);
    updateStickyDetail('duo');
  } else {
    selectBundle(duoOpt);
  }
}

// Sticky bar reveal
(function() {
  var cta = document.querySelector('.bb-cta-wrap');
  var bar = document.getElementById('sticky-buy');
  if (!cta || !bar) return;
  new IntersectionObserver(function(entries) {
    var e = entries[0];
    bar.classList.toggle('visible', !e.isIntersecting && e.boundingClientRect.top < 0);
  }, { threshold: 0 }).observe(cta);
})();

// Announcement bar rotation
(function() {
  var items = document.querySelectorAll('.ann-item');
  if (!items.length) return;
  var idx = 0;
  setInterval(function() {
    items[idx].classList.remove('active');
    idx = (idx + 1) % items.length;
    items[idx].classList.add('active');
  }, 3200);
})();

// FAQ accordion
document.querySelectorAll('.faq-q').forEach(function(q) {
  q.addEventListener('click', function() {
    q.parentElement.classList.toggle('open');
  });
});

// ── GALERIA SWIPE (mobile) ──
(function() {
  var gallery = document.getElementById('gallery-main');
  if (!gallery) return;
  var startX = 0, startY = 0;

  gallery.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });

  gallery.addEventListener('touchend', function(e) {
    var dx = e.changedTouches[0].clientX - startX;
    var dy = e.changedTouches[0].clientY - startY;
    if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;

    var thumbs = Array.from(document.querySelectorAll('.gallery-thumb[data-src]'));
    if (!thumbs.length) return;

    var activeIdx = thumbs.findIndex(function(t) { return t.classList.contains('active'); });
    var nextIdx = dx < 0
      ? (activeIdx + 1) % thumbs.length
      : (activeIdx - 1 + thumbs.length) % thumbs.length;

    selectThumb(thumbs[nextIdx], nextIdx);
  }, { passive: true });
})();

// ── GALLERY INDICATORS ──
(function() {
  var thumbs = Array.from(document.querySelectorAll('.gallery-thumb[data-src]'));
  var container = document.getElementById('gallery-indicators');
  if (!container || thumbs.length < 2) return;

  // Build indicators
  thumbs.forEach(function(_, i) {
    var ind = document.createElement('div');
    ind.className = 'gallery-indicator' + (i === 0 ? ' active' : '');
    // Width: active = 20px, inactive = 6px
    ind.style.width = i === 0 ? '20px' : '6px';
    ind.addEventListener('click', function() { selectThumb(thumbs[i], i); });
    container.appendChild(ind);
  });

  // Override selectThumb to also update indicators
  var origSelectThumb = selectThumb;
  selectThumb = function(el, idx) {
    origSelectThumb(el, idx);
    var indicators = container.querySelectorAll('.gallery-indicator');
    indicators.forEach(function(ind, i) {
      if (i === idx) {
        ind.classList.add('active');
        ind.style.width = '20px';
      } else {
        ind.classList.remove('active');
        ind.style.width = '6px';
      }
    });
  };
})();

// ── GALLERY ARROWS (desktop) ──
function galleryNav(dir) {
  var thumbs = Array.from(document.querySelectorAll('.gallery-thumb[data-src]'));
  if (!thumbs.length) return;
  var activeIdx = thumbs.findIndex(function(t) { return t.classList.contains('active'); });
  var nextIdx = activeIdx + dir;
  if (nextIdx < 0 || nextIdx >= thumbs.length) return;
  selectThumb(thumbs[nextIdx], nextIdx);
}

// ── INIT CTA ao carregar ──
(function() {
  var activeBundle = document.querySelector('.bb-opt.is-active');
  if (activeBundle) {
    var bundle = activeBundle.dataset.bundle;
    var d = bundleData[bundle];
    if (d) {
      updateCta(bundle, d.price);
      updateStickyDetail(bundle);
    }
  }
})();

// ── ?bundle=duo (vindo do quiz da home): abre a página já com o Duo seleccionado ──
(function() {
  try {
    if (new URLSearchParams(window.location.search).get('bundle') !== 'duo') return;
    var duoOpt = document.querySelector('.bb-opt[data-bundle="duo"]');
    if (duoOpt && !duoOpt.classList.contains('is-active')) selectBundle(duoOpt);
  } catch (e) { /* sem URLSearchParams */ }
})();
